
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./AppRoutes";
import { AuthProvider } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { SecurityProvider } from "@/context/SecurityContext";

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useEffect(() => {
    // Handle Android edge-to-edge display
    const handleAndroidEdgeToEdge = () => {
      if (window.navigator.userAgent.includes('Android')) {
        // Add meta viewport for edge-to-edge
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
        }
        
        // Add safe area classes to body
        document.body.classList.add('safe-area-all');
      }
    };

    handleAndroidEdgeToEdge();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SubscriptionProvider>
          <SecurityProvider>
            <Router>
              <div className="min-h-screen bg-background">
                <AppRoutes />
                <Toaster position="top-right" richColors closeButton />
              </div>
            </Router>
          </SecurityProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
